module.exports = __webpack_public_path__ + "static/media/AlmondStage10Onwards.71c1e34b.PNG";